import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormBuilder, FormsModule } from '@angular/forms';
import { faPlus, faTimes } from '@fortawesome/free-solid-svg-icons';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { interval } from 'rxjs';
import { debounce } from 'rxjs/operators';

@Component({
  selector: 'app-activity-attribute-restriction',
  templateUrl: './activity-attribute-restriction.component.html',
  styleUrls: ['./activity-attribute-restriction.component.scss'],
})
export class ActivityAttributeRestrictionComponent implements OnInit {
  @Input() activityAttributeRestriction: any;
  attribConditions: any;
  trueFalse: any;
  faTimes = faTimes;
  faPlus = faPlus;
  @Output() public inputChangeEmitter: EventEmitter<any> = new EventEmitter(true);
  debouncer: Subject<string> = new Subject<string>();

  constructor(
    private router: ActivatedRoute,
    private formBuilder: UntypedFormBuilder,
    private formsModule: FormsModule,
    private modalHelper: NgbModal
  ) {
    this.debouncer.pipe(debounce(() => interval(1000))).subscribe((value) => this.inputChangeEmitter.emit(value));
  }

  ngOnInit(): void {
    console.log(this.activityAttributeRestriction);
    this.attribConditions = [
      { value: true, text: 'HAS' },
      { value: false, text: 'DOES NOT HAVE' },
    ];
  }

  initRestrictionObject(): void {
    console.log(this.activityAttributeRestriction);
    var tmpObj = {
      attrValue: '(.*)',
      class:
        'com.chiprewards.cheetah.business.rules.config.behavior.v2.BehaviorConfiguration$Restrictions$Behavioral$ActivityAttributeRestriction',
    };
    if (this.activityAttributeRestriction) {
      this.activityAttributeRestriction.push(tmpObj);
    } else {
      this.activityAttributeRestriction = [];
      this.activityAttributeRestriction.push(tmpObj);
    }
    console.log(this.activityAttributeRestriction);
  }

  updateRestrictions() {
    this.debouncer.next(this.activityAttributeRestriction);
  }

  removeRestriction(restriction) {
    this.activityAttributeRestriction.splice(this.activityAttributeRestriction.indexOf(restriction), 1);
    this.updateRestrictions();
  }
}
